/**
 * Configuration des données métiers pour les devis
 * Contient les tailles, désignations et configurations de matériaux
 * pour chaque corps de métier
 */

import { CorpsMetier } from '../types/subscription';

// ============================================================================
// CARRELEUR - Tailles et Désignations
// ============================================================================

export const TAILLES_CARRELAGE = [
  '10x10',
  '15x15',
  '20x20',
  '25x25',
  '30x30',
  '33x33',
  '40x40',
  '45x45',
  '50x50',
  '60x60',
  '75x75',
  '80x80',
  '90x90',
  '100x100',
  '120x120',
  // Formats rectangulaires
  '7.5x15',
  '7.5x30',
  '10x20',
  '15x30',
  '15x60',
  '15x90',
  '20x40',
  '20x60',
  '20x80',
  '20x120',
  '25x40',
  '30x60',
  '30x90',
  '40x80',
  '40x120',
  '45x90',
  '60x120',
  '75x150',
  '80x160',
  '100x100',
  '120x60',
  '120x120',
  '120x240',
  '120x280',
  // Formats parquet/lames
  '15x60',
  '15x90',
  '20x80',
  '20x100',
  '20x120',
  '25x100',
  '25x150',
];

export const DESIGNATIONS_CARRELAGE = [
  // Pose de carrelage
  'Pose de carrelage sol intérieur',
  'Pose de carrelage mural',
  'Pose de carrelage terrasse extérieure',
  'Pose de carrelage balcon',
  'Pose de carrelage escalier',
  'Pose de carrelage garage',
  'Pose de carrelage salle de bain',
  'Pose de carrelage cuisine',

  // Types de carrelage
  'Fourniture et pose carrelage grès cérame',
  'Fourniture et pose carrelage porcelaine',
  'Fourniture et pose carrelage pierre naturelle',
  'Fourniture et pose carrelage imitation parquet',
  'Fourniture et pose carrelage grand format',
  'Fourniture et pose mosaïque',

  // Préparation
  'Ragréage autolissant',
  'Préparation du support',
  'Dépose ancien carrelage',
  'Dépose ancien revêtement',
  'Chape de ravoirage',
  'Ponçage et nettoyage du sol',

  // Plinthes et finitions
  'Pose de plinthes carrelage',
  'Pose de plinthes bois',
  'Pose de baguette d\'angle',
  'Pose de nez de marche',
  'Pose de profilé de finition',

  // Joints
  'Joints de carrelage sol',
  'Joints de carrelage mural',
  'Joint de dilatation',
  'Joint silicone',

  // Faïence
  'Pose de faïence murale',
  'Pose de crédence cuisine',
  'Pose de faïence douche',
  'Pose de faïence baignoire',

  // Étanchéité
  'Étanchéité sous carrelage (SEL)',
  'Pose de bande d\'étanchéité',
  'Traitement des angles',

  // Travaux spécifiques
  'Création de douche à l\'italienne',
  'Pose receveur de douche',
  'Calepinage personnalisé',
  'Pose en chevron',
  'Pose en opus',

  // Fournitures
  'Colle carrelage',
  'Mortier joint',
  'Primaire d\'accrochage',
  'Profilé de dilatation',

  // Déplacement et divers
  'Frais de déplacement',
  'Évacuation gravats',
  'Protection des ouvrages',
  'Nettoyage de fin de chantier',
];

// ============================================================================
// PLOMBIER - Diamètres et Désignations
// ============================================================================

export const DIAMETRES_PLOMBERIE = [
  // PER (Polyéthylène Réticulé)
  'PER Ø12',
  'PER Ø16',
  'PER Ø20',
  'PER Ø25',

  // Cuivre
  'Cuivre Ø10',
  'Cuivre Ø12',
  'Cuivre Ø14',
  'Cuivre Ø16',
  'Cuivre Ø18',
  'Cuivre Ø22',
  'Cuivre Ø28',
  'Cuivre Ø32',
  'Cuivre Ø40',

  // PVC Évacuation
  'PVC Ø32',
  'PVC Ø40',
  'PVC Ø50',
  'PVC Ø63',
  'PVC Ø75',
  'PVC Ø90',
  'PVC Ø100',
  'PVC Ø110',
  'PVC Ø125',
  'PVC Ø160',

  // Multicouche
  'Multicouche Ø16',
  'Multicouche Ø20',
  'Multicouche Ø26',
  'Multicouche Ø32',
];

export const DESIGNATIONS_PLOMBERIE = [
  // Installation sanitaire
  'Installation lavabo avec robinetterie',
  'Installation évier cuisine avec mitigeur',
  'Installation douche complète',
  'Installation baignoire avec robinetterie',
  'Installation WC suspendu avec bâti support',
  'Installation WC au sol',
  'Installation lave-mains',
  'Installation bidet',

  // Fourniture et installation
  'Fourniture et installation lavabo PMR',
  'Fourniture et installation douche à l\'italienne',
  'Fourniture et installation colonne de douche',
  'Fourniture et installation mitigeur thermostatique',
  'Fourniture et installation robinet extérieur',

  // Réseau eau froide/chaude
  'Création réseau eau froide complet',
  'Création réseau eau chaude complet',
  'Extension réseau eau froide',
  'Extension réseau eau chaude',
  'Alimentation en PER',
  'Alimentation en cuivre',
  'Alimentation en multicouche',

  // Évacuation
  'Création réseau évacuation complète',
  'Évacuation eaux usées',
  'Évacuation eaux vannes',
  'Raccordement au tout-à-l\'égout',
  'Installation siphon de sol',
  'Installation regard de visite',

  // Chauffage
  'Installation radiateur avec robinet thermostatique',
  'Dépose ancien radiateur',
  'Remplacement radiateur',
  'Installation plancher chauffant',
  'Installation chaudière gaz',
  'Installation chaudière électrique',
  'Installation ballon d\'eau chaude',
  'Installation chauffe-eau thermodynamique',
  'Installation pompe à chaleur',

  // Travaux spécifiques
  'Déplacement arrivée d\'eau',
  'Déplacement évacuation',
  'Création piquage sur colonne',
  'Installation nourrice',
  'Installation vanne d\'arrêt',
  'Installation réducteur de pression',
  'Installation disconnecteur',
  'Installation clapet anti-retour',

  // Réparations
  'Réparation fuite',
  'Détartrage chauffe-eau',
  'Remplacement groupe de sécurité',
  'Remplacement siphon',
  'Débouchage canalisation',
  'Inspection caméra',

  // Accessoires
  'Fourniture et pose porte-serviettes chauffant',
  'Fourniture et pose sèche-serviettes électrique',
  'Installation mitigeur douche',
  'Installation colonne de douche',
  'Installation barre de douche',

  // Divers
  'Mise en service installation',
  'Test d\'étanchéité',
  'Calorifugeage tuyauterie',
  'Protection gel',
  'Frais de déplacement',
  'Évacuation gravats',
  'Nettoyage de fin de chantier',
];

// ============================================================================
// ÉLECTRICIEN - Sections et Désignations
// ============================================================================

export const SECTIONS_CABLES = [
  // Câbles standards
  '1.5mm² (éclairage)',
  '2.5mm² (prises)',
  '4mm² (prises spécialisées)',
  '6mm² (plaques de cuisson)',
  '10mm² (four)',
  '16mm² (alimentation générale)',
  '25mm² (alimentation générale)',
  '35mm² (alimentation générale)',

  // Câbles spécifiques
  'RJ45 Cat 6 (réseau)',
  'Coaxial TV/SAT',
  'Câble téléphonique',
  'Câble alarme 4x0.75mm²',
  'Câble interphone/vidéophone',
  'Câble portier',
];

export const DESIGNATIONS_ELECTRICITE = [
  // Installation de base
  'Installation tableau électrique complet',
  'Remplacement tableau électrique',
  'Extension tableau électrique',
  'Mise aux normes tableau électrique',
  'Installation disjoncteur différentiel 30mA',
  'Installation disjoncteur divisionnaire',
  'Installation parafoudre',
  'Installation télérupteur',
  'Installation minuterie',
  'Installation contacteur jour/nuit',

  // Circuits électriques
  'Création circuit éclairage',
  'Création circuit prises',
  'Création circuit prises spécialisées',
  'Création circuit four',
  'Création circuit plaque de cuisson',
  'Création circuit lave-linge',
  'Création circuit lave-vaisselle',
  'Création circuit sèche-linge',
  'Création circuit chauffe-eau',
  'Création circuit VMC',
  'Création circuit climatisation',
  'Création circuit piscine',

  // Prises et interrupteurs
  'Installation prise électrique simple',
  'Installation prise électrique double',
  'Installation prise électrique triple',
  'Installation prise avec terre',
  'Installation prise étanche IP44',
  'Installation prise extérieure IP65',
  'Installation prise USB',
  'Installation interrupteur simple',
  'Installation interrupteur va-et-vient',
  'Installation interrupteur double',
  'Installation variateur',
  'Installation détecteur de mouvement',
  'Installation minuterie',

  // Éclairage
  'Installation point lumineux plafonnier',
  'Installation spot encastrable',
  'Installation spot LED',
  'Installation applique murale',
  'Installation réglette LED',
  'Installation bandeau LED',
  'Installation suspension',
  'Installation lustre',
  'Installation éclairage extérieur',
  'Installation projecteur LED',
  'Installation éclairage piscine',

  // Chauffage électrique
  'Installation radiateur électrique',
  'Installation convecteur',
  'Installation panneau rayonnant',
  'Installation sèche-serviettes',
  'Installation plancher chauffant électrique',
  'Installation programmateur chauffage',
  'Installation thermostat',
  'Installation thermostat connecté',

  // Réseau et communication
  'Installation prise RJ45',
  'Installation coffret de communication',
  'Installation boîtier DTI',
  'Installation prise TV/SAT',
  'Câblage réseau informatique',
  'Installation répéteur WiFi',
  'Installation point d\'accès WiFi',

  // Sécurité
  'Installation alarme intrusion',
  'Installation détecteur de fumée',
  'Installation détecteur de CO',
  'Installation système de vidéosurveillance',
  'Installation interphone',
  'Installation vidéophone',
  'Installation portail électrique',
  'Installation porte de garage motorisée',

  // Domotique
  'Installation système domotique',
  'Installation volets roulants électriques',
  'Installation store électrique',
  'Installation éclairage connecté',
  'Installation prise connectée',
  'Installation thermostat connecté',

  // Gros travaux
  'Saignées et rebouchage',
  'Pose de gaines électriques',
  'Pose de chemins de câbles',
  'Pose de goulottes',
  'Pose de plinthes électriques',
  'Tirage de câbles',

  // Extérieur
  'Installation éclairage jardin',
  'Installation borne extérieure',
  'Installation projecteur avec détecteur',
  'Installation prise extérieure',
  'Installation câble enterré',
  'Installation borne de recharge véhicule électrique',

  // Rénovation
  'Mise aux normes installation électrique',
  'Remplacement fusibles par disjoncteurs',
  'Remplacement prises sans terre',
  'Ajout de terre',
  'Mise en conformité NF C 15-100',
  'Diagnostic électrique',

  // Divers
  'Consuel (attestation de conformité)',
  'Frais de déplacement',
  'Évacuation gravats',
  'Nettoyage de fin de chantier',
  'Main d\'œuvre horaire',
  'Dépannage urgent',
];

// ============================================================================
// MAÇON - Dimensions et Désignations
// ============================================================================

export const DIMENSIONS_MACONNERIE = [
  // Épaisseurs de murs
  '5cm (cloison plâtre)',
  '7cm (cloison alvéolaire)',
  '10cm (cloison béton)',
  '15cm (mur porteur)',
  '20cm (mur porteur)',
  '25cm (mur porteur)',
  '30cm (mur extérieur)',

  // Parpaings standards
  'Parpaing 10x20x50',
  'Parpaing 15x20x50',
  'Parpaing 20x20x50',
  'Parpaing 25x20x50',

  // Briques
  'Brique 5x20x50',
  'Brique 10x20x50',
  'Brique 15x20x50',
  'Brique 20x20x50',

  // Dalles et chapes
  '5cm (dalle béton)',
  '8cm (dalle béton)',
  '10cm (dalle béton)',
  '12cm (dalle béton)',
  '15cm (dalle béton)',
  '20cm (dalle béton)',

  // Linteaux
  'Linteau 10cm',
  'Linteau 15cm',
  'Linteau 20cm',
];

export const DESIGNATIONS_MACONNERIE = [
  // Fondations et soubassement
  'Fouille en tranchée',
  'Semelle filante béton armé',
  'Semelle isolée béton armé',
  'Radier général béton armé',
  'Longrine béton armé',
  'Mur de soubassement',
  'Drain périphérique',
  'Hérisson ventilé',
  'Film polyane étanche',

  // Élévation murs
  'Montage mur parpaing 10cm',
  'Montage mur parpaing 15cm',
  'Montage mur parpaing 20cm',
  'Montage mur parpaing 25cm',
  'Montage mur brique 10cm',
  'Montage mur brique 15cm',
  'Montage mur brique 20cm',
  'Montage cloison alvéolaire 7cm',
  'Montage cloison béton cellulaire 7cm',
  'Montage cloison béton cellulaire 10cm',

  // Linteaux et poutres
  'Pose linteau béton préfabriqué',
  'Coulage linteau béton sur mesure',
  'Pose poutre béton',
  'Pose IPN métallique',
  'Pose poutre bois',

  // Dalles et planchers
  'Dalle béton armé intérieure',
  'Dalle béton armé extérieure',
  'Dalle béton terrasse',
  'Dalle béton garage',
  'Chape de ravoirage',
  'Chape liquide autonivelante',
  'Chape traditionnelle',
  'Chape anhydrite',
  'Plancher hourdis + poutrelles',
  'Plancher béton précontraint',

  // Enduits et finitions
  'Enduit de façade traditionnel',
  'Enduit monocouche projeté',
  'Enduit décoratif gratté',
  'Enduit décoratif lissé',
  'Enduit intérieur au plâtre',
  'Gobetis d\'accroche',
  'Ragréage mural',

  // Ouvertures
  'Création ouverture dans mur porteur',
  'Création ouverture dans cloison',
  'Réalisation appui de fenêtre',
  'Coffrage tableau de porte',
  'Seuil de porte béton',
  'Ébrasement baie vitrée',

  // Escaliers
  'Escalier béton coulé sur place',
  'Escalier béton préfabriqué',
  'Escalier extérieur béton',
  'Nez de marche',
  'Palier béton',
  'Garde-corps béton',

  // Rénovation et démolition
  'Démolition mur porteur',
  'Démolition cloison',
  'Démolition dalle béton',
  'Démolition escalier',
  'Dépose carrelage',
  'Dépose chape',
  'Piquetage enduit',
  'Burinage béton',

  // Reprises et consolidation
  'Reprise en sous-œuvre',
  'Consolidation mur fissuré',
  'Injection résine fissures',
  'Renforcement structure',
  'Micropieux fondation',
  'Chaînage béton armé',

  // Travaux extérieurs
  'Terrasse béton',
  'Allée piétonne béton',
  'Allée carrossable béton',
  'Muret de clôture',
  'Mur de soutènement',
  'Pilier portail',
  'Seuil de garage',
  'Descente de garage',

  // Assainissement
  'Fosse septique béton',
  'Regard béton préfabriqué',
  'Regard maçonné sur mesure',
  'Caniveau béton',
  'Puisard de drainage',

  // Étanchéité
  'Membrane d\'étanchéité sous-sol',
  'Cuvelage cave',
  'Drainage périphérique',
  'Traitement anti-humidité mur',
  'Injection résine anti-humidité',

  // Isolation
  'Isolation thermique extérieure (ITE)',
  'Isolation thermique intérieure (ITI)',
  'Doublage mur isolant',
  'Isolant sous dalle',
  'Isolant plancher',

  // Aménagements
  'Création cave enterrée',
  'Aménagement vide sanitaire',
  'Création local technique',
  'Fermeture de porte',
  'Fermeture de fenêtre',
  'Rebouchage tranchée',

  // Fournitures
  'Parpaings creux 20x20x50',
  'Briques creuses',
  'Mortier traditionnel',
  'Ciment gris',
  'Sable à maçonner',
  'Gravier béton',
  'Fers à béton',
  'Treillis soudé',
  'Planelles isolantes',

  // Prestations complémentaires
  'Ferraillage dalle',
  'Coffrage bois',
  'Étaiement provisoire',
  'Bétonnière/Toupie béton',
  'Location échafaudage',
  'Pompe à béton',
  'Carottage béton',
  'Sciage béton',

  // Divers
  'Frais de déplacement',
  'Évacuation gravats',
  'Location benne',
  'Nettoyage de chantier',
  'Protection ouvrages',
  'Main d\'œuvre horaire',
];

// ============================================================================
// Configuration des matériaux par type de pièce
// ============================================================================

export interface ConfigConsommable {
  nom: string;
  baseQuantiteParUnite: number; // Quantité de base par unité (m², ml, pièce)
  prixUnitaire: number;
  unite: string; // unité de mesure (kg, ml, pièce, etc.)
  obligatoire: boolean;
}

export type TypePiecePlomberie =
  | 'salle_de_bain'
  | 'cuisine'
  | 'wc'
  | 'buanderie'
  | 'exterieur'
  | 'chauffage'
  | 'general';

export type TypePieceElectricite =
  | 'piece_vie'
  | 'chambre'
  | 'cuisine'
  | 'salle_de_bain'
  | 'exterieur'
  | 'garage'
  | 'tableau'
  | 'general';

export type TypePieceMaconnerie =
  | 'fondation'
  | 'mur_porteur'
  | 'cloison'
  | 'dalle_interieur'
  | 'dalle_exterieur'
  | 'escalier'
  | 'terrasse'
  | 'extension'
  | 'general';

// Configuration matériaux PLOMBERIE par type de pièce
// baseQuantiteParUnite représente la quantité pour 1 mètre linéaire de tuyauterie
export const CONSOMMABLES_PLOMBERIE: Record<TypePiecePlomberie, ConfigConsommable[]> = {
  salle_de_bain: [
    { nom: 'Tube PER Ø16 (eau froide)', baseQuantiteParUnite: 1, prixUnitaire: 1.2, unite: 'ml', obligatoire: true },
    { nom: 'Tube PER Ø16 (eau chaude)', baseQuantiteParUnite: 1, prixUnitaire: 1.2, unite: 'ml', obligatoire: true },
    { nom: 'Tube PVC Ø100 (évacuation)', baseQuantiteParUnite: 0.4, prixUnitaire: 3.5, unite: 'ml', obligatoire: true },
    { nom: 'Raccords PER', baseQuantiteParUnite: 0.4, prixUnitaire: 2.5, unite: 'pièce', obligatoire: true },
    { nom: 'Raccords PVC', baseQuantiteParUnite: 0.25, prixUnitaire: 3.2, unite: 'pièce', obligatoire: true },
    { nom: 'Colliers de fixation', baseQuantiteParUnite: 1.5, prixUnitaire: 0.8, unite: 'pièce', obligatoire: true },
    { nom: 'Téflon/Filasse', baseQuantiteParUnite: 0.3, prixUnitaire: 3, unite: 'rouleau', obligatoire: true },
  ],
  cuisine: [
    { nom: 'Tube PER Ø16 (eau froide)', baseQuantiteParUnite: 1, prixUnitaire: 1.2, unite: 'ml', obligatoire: true },
    { nom: 'Tube PER Ø16 (eau chaude)', baseQuantiteParUnite: 1, prixUnitaire: 1.2, unite: 'ml', obligatoire: true },
    { nom: 'Tube PVC Ø50 (évacuation)', baseQuantiteParUnite: 0.3, prixUnitaire: 2.8, unite: 'ml', obligatoire: true },
    { nom: 'Raccords PER', baseQuantiteParUnite: 0.35, prixUnitaire: 2.5, unite: 'pièce', obligatoire: true },
    { nom: 'Colliers de fixation', baseQuantiteParUnite: 1.5, prixUnitaire: 0.8, unite: 'pièce', obligatoire: true },
    { nom: 'Téflon/Filasse', baseQuantiteParUnite: 0.2, prixUnitaire: 3, unite: 'rouleau', obligatoire: true },
  ],
  wc: [
    { nom: 'Tube PER Ø12 (eau froide)', baseQuantiteParUnite: 1, prixUnitaire: 0.9, unite: 'ml', obligatoire: true },
    { nom: 'Tube PVC Ø100 (évacuation)', baseQuantiteParUnite: 0.5, prixUnitaire: 3.5, unite: 'ml', obligatoire: true },
    { nom: 'Raccords PER', baseQuantiteParUnite: 0.3, prixUnitaire: 2.5, unite: 'pièce', obligatoire: true },
    { nom: 'Colliers de fixation', baseQuantiteParUnite: 1.5, prixUnitaire: 0.8, unite: 'pièce', obligatoire: true },
  ],
  buanderie: [
    { nom: 'Tube PER Ø16 (eau froide)', baseQuantiteParUnite: 1, prixUnitaire: 1.2, unite: 'ml', obligatoire: true },
    { nom: 'Tube PER Ø16 (eau chaude)', baseQuantiteParUnite: 1, prixUnitaire: 1.2, unite: 'ml', obligatoire: true },
    { nom: 'Tube PVC Ø50 (évacuation)', baseQuantiteParUnite: 0.6, prixUnitaire: 2.8, unite: 'ml', obligatoire: true },
    { nom: 'Raccords PER', baseQuantiteParUnite: 0.3, prixUnitaire: 2.5, unite: 'pièce', obligatoire: true },
    { nom: 'Colliers de fixation', baseQuantiteParUnite: 1.5, prixUnitaire: 0.8, unite: 'pièce', obligatoire: true },
  ],
  exterieur: [
    { nom: 'Tube PER Ø20 (eau froide)', baseQuantiteParUnite: 1, prixUnitaire: 1.5, unite: 'ml', obligatoire: true },
    { nom: 'Raccords PER', baseQuantiteParUnite: 0.25, prixUnitaire: 2.5, unite: 'pièce', obligatoire: true },
    { nom: 'Collier de fixation', baseQuantiteParUnite: 1.5, prixUnitaire: 1.2, unite: 'pièce', obligatoire: true },
    { nom: 'Gaine de protection', baseQuantiteParUnite: 0.5, prixUnitaire: 1.8, unite: 'ml', obligatoire: true },
  ],
  chauffage: [
    { nom: 'Tube PER Ø16 (chauffage)', baseQuantiteParUnite: 1, prixUnitaire: 1.4, unite: 'ml', obligatoire: true },
    { nom: 'Raccords PER', baseQuantiteParUnite: 0.35, prixUnitaire: 2.5, unite: 'pièce', obligatoire: true },
    { nom: 'Colliers de fixation', baseQuantiteParUnite: 1.5, prixUnitaire: 0.8, unite: 'pièce', obligatoire: true },
    { nom: 'Isolant tuyau', baseQuantiteParUnite: 0.8, prixUnitaire: 2, unite: 'ml', obligatoire: true },
  ],
  general: [
    { nom: 'Tube PER Ø16', baseQuantiteParUnite: 1, prixUnitaire: 1.2, unite: 'ml', obligatoire: true },
    { nom: 'Raccords PER', baseQuantiteParUnite: 0.3, prixUnitaire: 2.5, unite: 'pièce', obligatoire: true },
    { nom: 'Colliers de fixation', baseQuantiteParUnite: 1.5, prixUnitaire: 0.8, unite: 'pièce', obligatoire: true },
  ],
};

// Configuration matériaux ÉLECTRICITÉ par type de pièce
// baseQuantiteParUnite représente la quantité pour 1 mètre linéaire de câblage
export const CONSOMMABLES_ELECTRICITE: Record<TypePieceElectricite, ConfigConsommable[]> = {
  piece_vie: [
    { nom: 'Câble 1.5mm² (éclairage)', baseQuantiteParUnite: 1, prixUnitaire: 0.45, unite: 'ml', obligatoire: true },
    { nom: 'Câble 2.5mm² (prises)', baseQuantiteParUnite: 1.2, prixUnitaire: 0.75, unite: 'ml', obligatoire: true },
    { nom: 'Boîte encastrement', baseQuantiteParUnite: 0.3, prixUnitaire: 0.8, unite: 'pièce', obligatoire: true },
    { nom: 'Gaine ICTA Ø20', baseQuantiteParUnite: 1.1, prixUnitaire: 0.3, unite: 'ml', obligatoire: true },
    { nom: 'Dominos/Wagos', baseQuantiteParUnite: 0.4, prixUnitaire: 0.5, unite: 'pièce', obligatoire: true },
  ],
  chambre: [
    { nom: 'Câble 1.5mm² (éclairage)', baseQuantiteParUnite: 1, prixUnitaire: 0.45, unite: 'ml', obligatoire: true },
    { nom: 'Câble 2.5mm² (prises)', baseQuantiteParUnite: 1.2, prixUnitaire: 0.75, unite: 'ml', obligatoire: true },
    { nom: 'Boîte encastrement', baseQuantiteParUnite: 0.25, prixUnitaire: 0.8, unite: 'pièce', obligatoire: true },
    { nom: 'Gaine ICTA Ø20', baseQuantiteParUnite: 1.1, prixUnitaire: 0.3, unite: 'ml', obligatoire: true },
    { nom: 'Dominos/Wagos', baseQuantiteParUnite: 0.3, prixUnitaire: 0.5, unite: 'pièce', obligatoire: true },
  ],
  cuisine: [
    { nom: 'Câble 1.5mm² (éclairage)', baseQuantiteParUnite: 1, prixUnitaire: 0.45, unite: 'ml', obligatoire: true },
    { nom: 'Câble 2.5mm² (prises standards)', baseQuantiteParUnite: 1.2, prixUnitaire: 0.75, unite: 'ml', obligatoire: true },
    { nom: 'Câble 6mm² (plaque cuisson)', baseQuantiteParUnite: 0.5, prixUnitaire: 2.2, unite: 'ml', obligatoire: false },
    { nom: 'Boîte encastrement', baseQuantiteParUnite: 0.4, prixUnitaire: 0.8, unite: 'pièce', obligatoire: true },
    { nom: 'Gaine ICTA Ø20', baseQuantiteParUnite: 1.1, prixUnitaire: 0.3, unite: 'ml', obligatoire: true },
    { nom: 'Dominos/Wagos', baseQuantiteParUnite: 0.5, prixUnitaire: 0.5, unite: 'pièce', obligatoire: true },
  ],
  salle_de_bain: [
    { nom: 'Câble 1.5mm² (éclairage)', baseQuantiteParUnite: 1, prixUnitaire: 0.45, unite: 'ml', obligatoire: true },
    { nom: 'Câble 2.5mm² (prises)', baseQuantiteParUnite: 1, prixUnitaire: 0.75, unite: 'ml', obligatoire: true },
    { nom: 'Boîte étanche IP44', baseQuantiteParUnite: 0.3, prixUnitaire: 2.5, unite: 'pièce', obligatoire: true },
    { nom: 'Gaine ICTA Ø20', baseQuantiteParUnite: 1, prixUnitaire: 0.3, unite: 'ml', obligatoire: true },
    { nom: 'Dominos/Wagos étanches', baseQuantiteParUnite: 0.4, prixUnitaire: 0.8, unite: 'pièce', obligatoire: true },
  ],
  exterieur: [
    { nom: 'Câble 1.5mm² (éclairage)', baseQuantiteParUnite: 1, prixUnitaire: 0.45, unite: 'ml', obligatoire: true },
    { nom: 'Câble 2.5mm² (prises)', baseQuantiteParUnite: 0.75, prixUnitaire: 0.75, unite: 'ml', obligatoire: true },
    { nom: 'Gaine TPC Ø63 (enterrée)', baseQuantiteParUnite: 0.5, prixUnitaire: 1.8, unite: 'ml', obligatoire: true },
    { nom: 'Boîte étanche IP65', baseQuantiteParUnite: 0.15, prixUnitaire: 4.5, unite: 'pièce', obligatoire: true },
    { nom: 'Dominos étanches', baseQuantiteParUnite: 0.3, prixUnitaire: 1, unite: 'pièce', obligatoire: true },
  ],
  garage: [
    { nom: 'Câble 1.5mm² (éclairage)', baseQuantiteParUnite: 1, prixUnitaire: 0.45, unite: 'ml', obligatoire: true },
    { nom: 'Câble 2.5mm² (prises)', baseQuantiteParUnite: 1, prixUnitaire: 0.75, unite: 'ml', obligatoire: true },
    { nom: 'Gaine ICTA Ø20', baseQuantiteParUnite: 1, prixUnitaire: 0.3, unite: 'ml', obligatoire: true },
    { nom: 'Boîte saillie', baseQuantiteParUnite: 0.25, prixUnitaire: 1.2, unite: 'pièce', obligatoire: true },
    { nom: 'Dominos/Wagos', baseQuantiteParUnite: 0.4, prixUnitaire: 0.5, unite: 'pièce', obligatoire: true },
  ],
  tableau: [
    { nom: 'Câble 10mm² (alimentation)', baseQuantiteParUnite: 0.5, prixUnitaire: 3.5, unite: 'ml', obligatoire: true },
    { nom: 'Câble terre 6mm²', baseQuantiteParUnite: 0.3, prixUnitaire: 2, unite: 'ml', obligatoire: true },
    { nom: 'Borniers de connexion', baseQuantiteParUnite: 0.1, prixUnitaire: 8, unite: 'lot', obligatoire: true },
    { nom: 'Étiquettes repérage', baseQuantiteParUnite: 0.2, prixUnitaire: 5, unite: 'planche', obligatoire: true },
  ],
  general: [
    { nom: 'Câble 1.5mm²', baseQuantiteParUnite: 1, prixUnitaire: 0.45, unite: 'ml', obligatoire: true },
    { nom: 'Câble 2.5mm²', baseQuantiteParUnite: 1, prixUnitaire: 0.75, unite: 'ml', obligatoire: true },
    { nom: 'Gaine ICTA Ø20', baseQuantiteParUnite: 1, prixUnitaire: 0.3, unite: 'ml', obligatoire: true },
    { nom: 'Boîte encastrement', baseQuantiteParUnite: 0.2, prixUnitaire: 0.8, unite: 'pièce', obligatoire: true },
    { nom: 'Dominos/Wagos', baseQuantiteParUnite: 0.3, prixUnitaire: 0.5, unite: 'pièce', obligatoire: true },
  ],
};

// Configuration matériaux MAÇONNERIE par type d'ouvrage
// baseQuantiteParUnite représente la quantité pour 1 m² ou 1 ml selon le type d'ouvrage
export const CONSOMMABLES_MACONNERIE: Record<TypePieceMaconnerie, ConfigConsommable[]> = {
  fondation: [
    { nom: 'Béton dosé à 350kg/m³', baseQuantiteParUnite: 0.25, prixUnitaire: 135, unite: 'm³', obligatoire: true },
    { nom: 'Ferraillage HA Ø8-Ø12', baseQuantiteParUnite: 8, prixUnitaire: 1.8, unite: 'kg', obligatoire: true },
    { nom: 'Film polyane 150µ', baseQuantiteParUnite: 1.1, prixUnitaire: 0.3, unite: 'm²', obligatoire: true },
    { nom: 'Sable de remblai', baseQuantiteParUnite: 0.15, prixUnitaire: 25, unite: 'm³', obligatoire: false },
    { nom: 'Drain agricole Ø100', baseQuantiteParUnite: 0.5, prixUnitaire: 3.5, unite: 'ml', obligatoire: false },
  ],
  mur_porteur: [
    { nom: 'Parpaing 20x20x50 (creux)', baseQuantiteParUnite: 10, prixUnitaire: 1.35, unite: 'pièce', obligatoire: true },
    { nom: 'Mortier traditionnel', baseQuantiteParUnite: 0.015, prixUnitaire: 95, unite: 'm³', obligatoire: true },
    { nom: 'Chaînage horizontal béton', baseQuantiteParUnite: 0.3, prixUnitaire: 4.5, unite: 'ml', obligatoire: true },
    { nom: 'Fers à béton Ø8-Ø10', baseQuantiteParUnite: 3, prixUnitaire: 1.6, unite: 'kg', obligatoire: true },
    { nom: 'Planelle isolante 5cm', baseQuantiteParUnite: 2, prixUnitaire: 3.2, unite: 'ml', obligatoire: false },
  ],
  cloison: [
    { nom: 'Carreau béton cellulaire 7cm', baseQuantiteParUnite: 8, prixUnitaire: 2.8, unite: 'pièce', obligatoire: true },
    { nom: 'Colle mortier spécial', baseQuantiteParUnite: 0.005, prixUnitaire: 18, unite: 'sac 25kg', obligatoire: true },
    { nom: 'Bande d\'étanchéité', baseQuantiteParUnite: 0.5, prixUnitaire: 2.5, unite: 'ml', obligatoire: false },
  ],
  dalle_interieur: [
    { nom: 'Béton dosé à 350kg/m³', baseQuantiteParUnite: 0.12, prixUnitaire: 135, unite: 'm³', obligatoire: true },
    { nom: 'Treillis soudé ST25', baseQuantiteParUnite: 1.1, prixUnitaire: 2.5, unite: 'm²', obligatoire: true },
    { nom: 'Film polyane 200µ', baseQuantiteParUnite: 1.1, prixUnitaire: 0.45, unite: 'm²', obligatoire: true },
    { nom: 'Isolant polystyrène 30mm', baseQuantiteParUnite: 1.05, prixUnitaire: 4.8, unite: 'm²', obligatoire: false },
    { nom: 'Bande périphérique désolidarisation', baseQuantiteParUnite: 0.4, prixUnitaire: 1.8, unite: 'ml', obligatoire: true },
  ],
  dalle_exterieur: [
    { nom: 'Béton dosé à 350kg/m³ (fibré)', baseQuantiteParUnite: 0.15, prixUnitaire: 145, unite: 'm³', obligatoire: true },
    { nom: 'Treillis soudé ST25C', baseQuantiteParUnite: 1.1, prixUnitaire: 3.2, unite: 'm²', obligatoire: true },
    { nom: 'Film polyane 200µ', baseQuantiteParUnite: 1.1, prixUnitaire: 0.45, unite: 'm²', obligatoire: true },
    { nom: 'Hérisson pierre 0/31.5', baseQuantiteParUnite: 0.2, prixUnitaire: 28, unite: 'm³', obligatoire: true },
    { nom: 'Joint de dilatation', baseQuantiteParUnite: 0.3, prixUnitaire: 4.5, unite: 'ml', obligatoire: true },
  ],
  escalier: [
    { nom: 'Béton dosé à 350kg/m³', baseQuantiteParUnite: 0.25, prixUnitaire: 135, unite: 'm³', obligatoire: true },
    { nom: 'Ferraillage HA Ø10-Ø12', baseQuantiteParUnite: 15, prixUnitaire: 1.8, unite: 'kg', obligatoire: true },
    { nom: 'Coffrage bois contreplaqué', baseQuantiteParUnite: 2.5, prixUnitaire: 12, unite: 'm²', obligatoire: true },
    { nom: 'Huile décoffrage', baseQuantiteParUnite: 0.15, prixUnitaire: 8.5, unite: 'L', obligatoire: true },
  ],
  terrasse: [
    { nom: 'Béton désactivé dosé 350kg/m³', baseQuantiteParUnite: 0.12, prixUnitaire: 155, unite: 'm³', obligatoire: true },
    { nom: 'Treillis soudé ST25C', baseQuantiteParUnite: 1.1, prixUnitaire: 3.2, unite: 'm²', obligatoire: true },
    { nom: 'Tout-venant compacté 0/31.5', baseQuantiteParUnite: 0.2, prixUnitaire: 28, unite: 'm³', obligatoire: true },
    { nom: 'Géotextile anti-contaminant', baseQuantiteParUnite: 1.1, prixUnitaire: 1.2, unite: 'm²', obligatoire: true },
    { nom: 'Joint de dilatation souple', baseQuantiteParUnite: 0.4, prixUnitaire: 4.5, unite: 'ml', obligatoire: true },
  ],
  extension: [
    { nom: 'Parpaing 20x20x50', baseQuantiteParUnite: 10, prixUnitaire: 1.35, unite: 'pièce', obligatoire: true },
    { nom: 'Mortier traditionnel', baseQuantiteParUnite: 0.015, prixUnitaire: 95, unite: 'm³', obligatoire: true },
    { nom: 'Béton dalle 350kg/m³', baseQuantiteParUnite: 0.15, prixUnitaire: 135, unite: 'm³', obligatoire: true },
    { nom: 'Ferraillage (fers + treillis)', baseQuantiteParUnite: 10, prixUnitaire: 1.8, unite: 'kg', obligatoire: true },
    { nom: 'Isolant PSE 100mm', baseQuantiteParUnite: 1.05, prixUnitaire: 8.5, unite: 'm²', obligatoire: true },
  ],
  general: [
    { nom: 'Ciment gris 32.5', baseQuantiteParUnite: 0.3, prixUnitaire: 8.5, unite: 'sac 35kg', obligatoire: true },
    { nom: 'Sable 0/4 lavé', baseQuantiteParUnite: 0.03, prixUnitaire: 32, unite: 'm³', obligatoire: true },
    { nom: 'Gravier 5/15', baseQuantiteParUnite: 0.02, prixUnitaire: 35, unite: 'm³', obligatoire: false },
  ],
};

// ============================================================================
// PEINTRE - Types de peinture et Désignations
// ============================================================================

export const TYPES_PEINTURE = [
  // Types de peinture
  'Acrylique (phase aqueuse)',
  'Glycéro (phase solvant)',
  'Monocouche',
  'Bicouche',
  'Mate',
  'Satinée',
  'Brillante',
  'Velours',

  // Peintures spéciales
  'Peinture anti-humidité',
  'Peinture lessivable',
  'Peinture cuisine et salle de bain',
  'Peinture radiateur',
  'Peinture sol',
  'Peinture bois extérieur',
  'Peinture fer et métal',
  'Peinture anti-rouille',

  // Enduits
  'Enduit de lissage',
  'Enduit de rebouchage',
  'Enduit décoratif',
  'Enduit à la chaux',
];

export const DESIGNATIONS_PEINTURE = [
  // Peinture murs et plafonds
  'Peinture mur intérieur acrylique mate',
  'Peinture mur intérieur acrylique satinée',
  'Peinture plafond blanc mat',
  'Peinture monocouche mur et plafond',
  'Peinture bicouche mur et plafond',
  'Lessivage et peinture mur',
  'Lessivage et peinture plafond',

  // Peintures spécialisées
  'Peinture cuisine et salle de bain (lessivable)',
  'Peinture anti-humidité',
  'Peinture anti-condensation',
  'Peinture anti-moisissures',
  'Peinture isolante thermique',
  'Peinture dépolluante',

  // Boiseries intérieures
  'Peinture porte intérieure (2 faces)',
  'Peinture porte intérieure (1 face)',
  'Peinture fenêtre intérieure',
  'Peinture plinthes bois',
  'Peinture lambris bois',
  'Peinture escalier bois',
  'Peinture garde-corps bois',
  'Lasure bois intérieur',
  'Vernis bois intérieur',

  // Boiseries extérieures
  'Peinture porte extérieure',
  'Peinture fenêtre extérieure',
  'Peinture volet bois',
  'Peinture bardage bois',
  'Peinture terrasse bois',
  'Lasure bois extérieur',
  'Saturateur bois extérieur',
  'Traitement insecticide et fongicide bois',

  // Métaux
  'Peinture portail métallique',
  'Peinture grille fer forgé',
  'Peinture radiateur',
  'Peinture gouttière',
  'Peinture garde-corps métal',
  'Peinture porte de garage métallique',
  'Traitement antirouille',
  'Peinture fer extérieur',

  // Sols
  'Peinture sol béton intérieur',
  'Peinture sol béton extérieur',
  'Peinture sol garage',
  'Peinture sol cave',
  'Résine époxy sol',
  'Résine polyuréthane sol',

  // Préparation support
  'Ponçage mur',
  'Ponçage plafond',
  'Ponçage boiseries',
  'Décapage peinture',
  'Décapage lasure',
  'Décapage papier peint',
  'Lessivage des murs',
  'Lessivage des plafonds',
  'Rebouchage fissures',
  'Rebouchage trous',
  'Lissage mur',
  'Lissage plafond',
  'Application sous-couche',
  'Application primaire d\'accrochage',
  'Application fixateur de fond',

  // Enduits décoratifs
  'Enduit décoratif à la chaux',
  'Enduit décoratif béton ciré',
  'Enduit décoratif stucco',
  'Enduit décoratif tadelakt',
  'Enduit à effet texture',
  'Enduit à la vénitienne',
  'Badigeon à la chaux',

  // Papier peint et revêtements
  'Dépose papier peint',
  'Pose papier peint intissé',
  'Pose papier peint traditionnel',
  'Pose papier peint vinyle',
  'Pose toile de verre',
  'Pose fibre de verre',
  'Peinture sur toile de verre',

  // Façades
  'Peinture façade acrylique',
  'Peinture façade siloxane',
  'Peinture façade pliolite',
  'Ravalement façade complet',
  'Nettoyage haute pression façade',
  'Traitement anti-mousse façade',
  'Hydrofuge façade',
  'Fixateur façade',

  // Travaux de finition
  'Protection sols et meubles',
  'Bâchage chantier',
  'Masquage surfaces',
  'Nettoyage fin de chantier',
  'Évacuation déchets',
  'Démontage/remontage radiateurs',
  'Démontage/remontage luminaires',
  'Retouches finales',

  // Fournitures
  'Peinture acrylique intérieure',
  'Peinture glycéro',
  'Sous-couche universelle',
  'Enduit de rebouchage',
  'Enduit de lissage',
  'White spirit',
  'Bâche de protection',
  'Ruban de masquage',

  // Divers
  'Frais de déplacement',
  'Location échafaudage',
  'Main d\'œuvre horaire',
  'Devis couleurs personnalisées',
  'Conseil décoration',
];

// Configuration matériaux PEINTURE par type de pièce
export type TypePiecePeinture =
  | 'piece_vie'
  | 'chambre'
  | 'cuisine'
  | 'salle_de_bain'
  | 'exterieur'
  | 'boiserie'
  | 'facade'
  | 'general';

export const CONSOMMABLES_PEINTURE: Record<TypePiecePeinture, ConfigConsommable[]> = {
  piece_vie: [
    { nom: 'Peinture acrylique mate (10L)', baseQuantiteParUnite: 0.08, prixUnitaire: 45, unite: 'L', obligatoire: true },
    { nom: 'Sous-couche (10L)', baseQuantiteParUnite: 0.06, prixUnitaire: 35, unite: 'L', obligatoire: true },
    { nom: 'Enduit de lissage', baseQuantiteParUnite: 0.5, prixUnitaire: 12, unite: 'kg', obligatoire: false },
    { nom: 'Ruban de masquage', baseQuantiteParUnite: 0.15, prixUnitaire: 4.5, unite: 'rouleau', obligatoire: true },
    { nom: 'Bâche de protection', baseQuantiteParUnite: 0.05, prixUnitaire: 8, unite: 'm²', obligatoire: true },
  ],
  chambre: [
    { nom: 'Peinture acrylique mate (10L)', baseQuantiteParUnite: 0.08, prixUnitaire: 45, unite: 'L', obligatoire: true },
    { nom: 'Sous-couche (10L)', baseQuantiteParUnite: 0.06, prixUnitaire: 35, unite: 'L', obligatoire: true },
    { nom: 'Enduit de lissage', baseQuantiteParUnite: 0.5, prixUnitaire: 12, unite: 'kg', obligatoire: false },
    { nom: 'Ruban de masquage', baseQuantiteParUnite: 0.15, prixUnitaire: 4.5, unite: 'rouleau', obligatoire: true },
  ],
  cuisine: [
    { nom: 'Peinture lessivable satinée (10L)', baseQuantiteParUnite: 0.08, prixUnitaire: 55, unite: 'L', obligatoire: true },
    { nom: 'Sous-couche spéciale cuisine (10L)', baseQuantiteParUnite: 0.06, prixUnitaire: 42, unite: 'L', obligatoire: true },
    { nom: 'Enduit de lissage', baseQuantiteParUnite: 0.6, prixUnitaire: 12, unite: 'kg', obligatoire: false },
    { nom: 'Ruban de masquage', baseQuantiteParUnite: 0.2, prixUnitaire: 4.5, unite: 'rouleau', obligatoire: true },
  ],
  salle_de_bain: [
    { nom: 'Peinture anti-humidité (10L)', baseQuantiteParUnite: 0.08, prixUnitaire: 62, unite: 'L', obligatoire: true },
    { nom: 'Sous-couche anti-humidité (10L)', baseQuantiteParUnite: 0.06, prixUnitaire: 48, unite: 'L', obligatoire: true },
    { nom: 'Traitement anti-moisissures', baseQuantiteParUnite: 0.05, prixUnitaire: 18, unite: 'L', obligatoire: false },
    { nom: 'Ruban de masquage', baseQuantiteParUnite: 0.15, prixUnitaire: 4.5, unite: 'rouleau', obligatoire: true },
  ],
  boiserie: [
    { nom: 'Peinture bois glycéro satinée (2.5L)', baseQuantiteParUnite: 0.15, prixUnitaire: 32, unite: 'L', obligatoire: true },
    { nom: 'Sous-couche bois (2.5L)', baseQuantiteParUnite: 0.12, prixUnitaire: 28, unite: 'L', obligatoire: true },
    { nom: 'Papier abrasif grain 120', baseQuantiteParUnite: 0.3, prixUnitaire: 2.5, unite: 'feuille', obligatoire: true },
    { nom: 'White spirit', baseQuantiteParUnite: 0.1, prixUnitaire: 8, unite: 'L', obligatoire: true },
  ],
  exterieur: [
    { nom: 'Peinture extérieure acrylique (10L)', baseQuantiteParUnite: 0.12, prixUnitaire: 75, unite: 'L', obligatoire: true },
    { nom: 'Sous-couche extérieure (10L)', baseQuantiteParUnite: 0.08, prixUnitaire: 55, unite: 'L', obligatoire: true },
    { nom: 'Fixateur de fond', baseQuantiteParUnite: 0.05, prixUnitaire: 22, unite: 'L', obligatoire: false },
    { nom: 'Bâche de protection', baseQuantiteParUnite: 0.08, prixUnitaire: 8, unite: 'm²', obligatoire: true },
  ],
  facade: [
    { nom: 'Peinture façade (15L)', baseQuantiteParUnite: 0.15, prixUnitaire: 95, unite: 'L', obligatoire: true },
    { nom: 'Fixateur façade (10L)', baseQuantiteParUnite: 0.08, prixUnitaire: 42, unite: 'L', obligatoire: true },
    { nom: 'Hydrofuge façade', baseQuantiteParUnite: 0.05, prixUnitaire: 58, unite: 'L', obligatoire: false },
    { nom: 'Nettoyant façade', baseQuantiteParUnite: 0.03, prixUnitaire: 15, unite: 'kg', obligatoire: false },
  ],
  general: [
    { nom: 'Peinture acrylique (10L)', baseQuantiteParUnite: 0.08, prixUnitaire: 45, unite: 'L', obligatoire: true },
    { nom: 'Sous-couche universelle (10L)', baseQuantiteParUnite: 0.06, prixUnitaire: 35, unite: 'L', obligatoire: true },
    { nom: 'Enduit de rebouchage', baseQuantiteParUnite: 0.3, prixUnitaire: 8, unite: 'kg', obligatoire: false },
  ],
};

// ============================================================================
// Helpers pour obtenir les données par métier
// ============================================================================

export const getTaillesByMetier = (metier: CorpsMetier): string[] => {
  switch (metier) {
    case CorpsMetier.CARRELEUR:
      return TAILLES_CARRELAGE;
    case CorpsMetier.PLOMBIER:
      return DIAMETRES_PLOMBERIE;
    case CorpsMetier.ELECTRICIEN:
      return SECTIONS_CABLES;
    case CorpsMetier.MACON:
      return DIMENSIONS_MACONNERIE;
    case CorpsMetier.PEINTRE:
      return TYPES_PEINTURE;
    default:
      return [];
  }
};

export const getDesignationsByMetier = (metier: CorpsMetier): string[] => {
  switch (metier) {
    case CorpsMetier.CARRELEUR:
      return DESIGNATIONS_CARRELAGE;
    case CorpsMetier.PLOMBIER:
      return DESIGNATIONS_PLOMBERIE;
    case CorpsMetier.ELECTRICIEN:
      return DESIGNATIONS_ELECTRICITE;
    case CorpsMetier.MACON:
      return DESIGNATIONS_MACONNERIE;
    case CorpsMetier.PEINTRE:
      return DESIGNATIONS_PEINTURE;
    default:
      return [];
  }
};

export const getTailleLabel = (metier: CorpsMetier): string => {
  switch (metier) {
    case CorpsMetier.CARRELEUR:
      return 'Taille carrelage';
    case CorpsMetier.PLOMBIER:
      return 'Diamètre/Type';
    case CorpsMetier.ELECTRICIEN:
      return 'Section câble';
    case CorpsMetier.MACON:
      return 'Épaisseur/Dimension';
    case CorpsMetier.PEINTRE:
      return 'Type de peinture';
    default:
      return 'Dimension';
  }
};
